export const __NotFoundLang = {
    title: 'صفحه مورد نظر یافت نشد',
    subTitle: 'صفحه ای مطابق با آدرس مورد نظر شما وجود ندارد. لطفا آدرس را بررسی و مجددا اقدام نمایید',
    back: 'بازگشت',
};
